import { render, staticRenderFns } from "./EditarConvenio.vue?vue&type=template&id=3bf47bf0&"
import script from "./EditarConvenio.vue?vue&type=script&lang=js&"
export * from "./EditarConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports